import './App.css';
import Fe from './component/Fe';
import Jv from './component/Jv';
import Oto1 from './component/oto1';
import Oto2 from './component/oto2';
import Oto3 from './component/oto3';
import PrivacyPolicy from './component/PrivacyPolicy';
import TermsOfService from './component/Terms-of-Service';
import EarningDisclaimer from './component/Earning-Disclaimer';
import ContactUs from './component/Contact-Us';
import PdfViewer from './component/PdfViewer';
import { BrowserRouter, Routes, Route } from "react-router-dom";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Fe />} />
        <Route path="/2.0fe" element={<Fe />} />
        <Route path="/2.0jv" element={<Jv />} />
        <Route path="/2.0oto1" element={<Oto1 />} />
        <Route path="/2.0oto2" element={<Oto2 />} />
        <Route path="/2.0oto3" element={<Oto3 />} />
        <Route path="/2.0privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/2.0Terms-of-Service" element={<TermsOfService />} />
        <Route path="/2.0Earning-Disclaimer" element={<EarningDisclaimer />} />
        <Route path="/2.0Contact-Us" element={<ContactUs />} /> 
        <Route path="/2.0pdf/:docType" element={<PdfViewer />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
